module.exports = __webpack_public_path__ + "static/img/19a.aaca5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/19a.jpg
// module id = clM0
// module chunks = 0